<template>
  <div class="container" style="background-color: #F7F7F7">
    <div class="binding">
      <div class="tips">
        <p>请绑定手机号码</p>
        <p>为了您的账号安全，请及时绑定手机</p>
      </div>
      <div class="binding-form">
        <van-field
          v-model="phonenum"
          placeholder="请输入手机号码"
        >
          <i slot="left-icon" class="iconfont iconshouji1"></i>
        </van-field>
        <van-field
          v-model="vcode"
          center
          placeholder="请输入验证码"
        >
          <i slot="left-icon" class="iconfont iconanquan1"></i>
          <button slot="button" class="getcode" :disabled="!canGetVcode" @click="getVcode">{{btnText}}</button>
        </van-field>
        <div class="binding-submit">
          <button :disabled="!canLogin" @click="binding">确认绑定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../interface/api'
  var clock = 60
  var t
  export default {
    name: 'binding',
    data () {
      return {
        phonenum: '',
        vcode: '',
        rcode: '',
        repeat: true,
        canLogin: true,
        btnText: '获取验证码',
        canGetVcode: true,
      }
    },
    created () {
      this.$toast.allowMultiple()
      // console.log(this.$route.query.type)
    },
    methods: {
      binding () {
      let phonenum = this.phonenum
      let vcode = this.vcode
      let rcode = this.rcode
      if (phonenum.replace(/[ 　]/gm, '').length < 1 && !phonenum) {
        this.$toast.fail('手机号不能为空')
        return
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(phonenum)) {
        this.$toast.fail('请输入正确的手机号')
        return
      }
      if (vcode.replace(/[ 　]/gm, '').length < 1 && !vcode) {
        this.$toast.fail('验证码不能为空')
        return
      }
      if (rcode.length < 1) {
        this.$toast('请获取验证码')
        return
      }
      this.canLogin = false

      const loading = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })

      this.$fetch.post(API.BINDPHONENUM, {
        phonenum: this.phonenum,
        vcode: this.vcode,
        rcode: this.rcode
      })
        .then(response => {
          if (response.status !== 200) {
            this.canLogin = true
            loading.clear();
            this.$toast.fail(response.message)
            return
          }
          this.$store.commit('login', response.data.tokenid)
          this.$store.commit('userinfo', response.data)
          loading.clear();
          clearTimeout(t)
          this.canGetVcode = true
          this.canLogin = true
          this.btnText = '获取验证码'
          clock = 60
          this.$toast.success({
            duration: 1500,
            message: '绑定成功!'
          })
          let type = this.$route.query.type ? this.$route.query.type : ''
          var _this = this
          setTimeout(function(){
            if (type === 'user') {
              _this.$router.replace({
                path: '/user'
              })
            } else {
              _this.$router.replace({
                path: '/result',
                query: {
                  type: type
                }
              })
            }
          },1500)
        })
        .catch((err) => {
          console.log(err)
          loading.clear();
          var msg = err.message ? err.message : '绑定失败'
          this.$toast(msg)
          this.canLogin = true
        })
      },
      getVcode () {
        if (this.repeat) {
          let phonenum = this.phonenum
          // if (this.$store.state.userinfo.phonenum) {
          //  this.$toast.fail('该帐号已绑定了手机')
          //  return
          // }
          if (phonenum.replace(/[ 　]/gm, '').length < 1 && !phonenum) {
            this.$toast.fail('手机号不能为空')
            return
          }
          if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(phonenum)) {
            this.$toast.fail('手机号不正确')
            return
          }
          this.repeat = false
          this.$fetch.get(API.SENDVCODE, {
            phonenum: phonenum
          })
          .then(response => {
            // console.log(response)
            if (response.status !== 200) {
              this.$toast.fail(response.message)
              return
            }
            this.rcode = response.data.rcode
            this.$toast.success('验证码发送成功')
            this.settime()
          })
          .catch(err => {
            console.log(err)
            this.$toast.fail('验证码发送失败')
          })
        }
      },
      settime () {
        if (clock === 0) {
          clearTimeout(t)
          this.repeat = true
          this.canGetVcode = true
          this.btnText = '获取验证码'
          clock = 60
          return
        } else {
          this.canGetVcode = false
          this.btnText = '重新发送(' + clock + ')'
          clock--
        }
        t = setTimeout(() => {
          this.settime()
        }, 1000)
      }
    }
  }
</script>

<style lang="stylus">
</style>